// @flow
import React from 'react';
import Author from './Author';
import Contacts from './Contacts';
import Copyright from './Copyright';
import Menu from './Menu';
import styles from './Sidebar.module.scss';
import { useSiteMetadata } from '../../hooks';

type Props = {
  isIndex?: boolean,
  onlyAuthor?: boolean,
};

const Sidebar = ({ isIndex, onlyAuthor }: Props) => {
  const { author, copyright, menu } = useSiteMetadata();

  if (onlyAuthor) {
    return (
      <div className={styles['sidebar']}>
        <div className={styles['sidebar__inner']}>
          <Author author={author} isIndex={isIndex} />
        </div>
      </div>
    );
  }
  return (
    <div className={styles['sidebar']}>
      <div className={styles['sidebar__inner']}>
        <Author author={author} isIndex={isIndex} />
        <Menu menu={menu} />
        <Contacts contacts={author.contacts} />
        <Copyright copyright={copyright} />
      </div>
    </div>
  );
};

export default Sidebar;
